import script from "./WhatsappButton.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsappButton.vue?vue&type=script&setup=true&lang=js"

import "./WhatsappButton.vue?vue&type=style&index=0&id=b6acf1d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6acf1d4"]])

export default __exports__